import script from "./SelectDescriptionTempModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectDescriptionTempModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectDescriptionTempModal.vue?vue&type=style&index=0&id=c2d7f958&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2d7f958"]])

export default __exports__